import React from 'react'
import {
  modalSeen,
  StorageType,
} from '@chegg-wt/core/components/Modals/ExitPopupCfcModals/utils'
import { PLAGIARISM_SCROLL_MODAL } from '@chegg-wt/core/state/modals/constants'
import { UCFUploadWidget } from '@chegg-wt/core/components/UCFUploadWidget'

export const UPLOAD_WIDGET_ID = 'upload-widget'

export const HEADING_TEXT = 'Check your paper for plagiarism errors'
export const SUBHEADING_TEXT = 'Make sure you didn’t forget a source or cite incorrectly'

export const onCtaClicked = () => {
  const session = StorageType.sessionStorage
  const local = StorageType.localStorage

  const shouldSetModalSeenPermanent =
    modalSeen(session).get(PLAGIARISM_SCROLL_MODAL) &&
    !modalSeen(local).get(PLAGIARISM_SCROLL_MODAL)

  if (shouldSetModalSeenPermanent) modalSeen(local).set(PLAGIARISM_SCROLL_MODAL)
}

const Widget: React.FunctionComponent = () => {
  return (
    <div data-test={UPLOAD_WIDGET_ID}>
      <UCFUploadWidget
        headingText={HEADING_TEXT}
        subheadingText={SUBHEADING_TEXT}
        onCtaClicked={onCtaClicked}
      />
    </div>
  )
}

export default Widget
